<template>
  <div>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="settleAccountsRef"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumns"
      :valid-config="{ autoPos: true, message: 'inline' }"
      height="400"
      :key="keyTime"
      @dblclickEvent="dblclickEvent"
    ></vxe-grid>
    <!-- 分页 -->
    <IPagination
      :total="tableTotal"
      :multipleSelection="multipleSelection"
      @changePageHandler="changePageHandler"
      ref="ipaginationRef"
    />
  </div>
</template>

<script>
  import jumpDetailMixin from '../mixins/jumpDetailMixin.js';
  import billDataMixin from '../mixins/billDataMixin.js';
  import { formatDate } from '@/utils';
  export default {
    name: 'BeingOverdue',
    props: ['orderName', 'activeTab', 'indexType'],
    mixins: [jumpDetailMixin, billDataMixin],
    data() {
      return {
        tableData: [],
        tableTotal: 0,
        multipleSelection: [],
        keyTime: new Date().getTime(),
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      };
    },
    computed: {
      tableColumns() {
        return [
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'orderTypeName',
            title: '合同类型',
            visible: true,
          },
          // {
          //   field: 'contractName',
          //   title: '合同名称',
          //   visible: true,
          // },
          {
            field: 'orderNo',
            title: '单据号',
            slots: {
              default: ({ row }) => {
                return [
                  <a href="javascript:void(0)" onClick={() => this.jumpToDetail(row)}>
                    {row.orderNo}
                  </a>,
                  //  row.receivableSettlementNo
                ];
              },
            },
            visible: true,
          },
          {
            field: 'customerName',
            title: '客户',
            visible: true,
          },
          {
            field: 'leaseDateUntil',
            title: '到期时间',
            visible: true,
          },
        ];
      },
    },
    mounted() {
      this.businessGroup = this.userInfo.businessGroup;
      this.getTableData();
      console.log(this.orderName);
    },
    methods: {
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
        this.page.pageNum = pageNum;
        this.page.pageSize = pageSize;
        // this.getDataByOrderType('03');
        this.getTableData(this.orderName);
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        // this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        // this.getData();
      },
      async getTableData() {
        const newData = new Date();
        const leaseDateUntilStart = formatDate(newData, true);
        const leaseDateUntilEnd = formatDate(
          new Date(newData.setDate(newData.getDate() + 30)),
          true
        );
        // const orderName = ;
        console.log('日期', this.orderName);
        this.getDataByOrderType('', this.orderName, leaseDateUntilStart, leaseDateUntilEnd);
      },
    },
    watch: {
      orderName: {
        handler(val) {
          console.log('到期表格数据变化', val);
          this.keyTime = new Date().getTime();
          if (this.activeTab == 'third') {
            // this.getTableData(val);
            this.changePageHandler(1, 10);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style></style>
